<template>
  <div class="page-404">
    <h1>404</h1>
    <p>抱歉，你访问的页面不存在</p>
    <a-button type="primary" size="large" @click="$router.push('/')">
      返回首页
    </a-button>
  </div>
</template>

<script>
    export default {
        name: 'Page404'
    }
</script>

<style scoped>
    .page-404 {
        text-align: center;
        display: flex;
        min-height: 100vh;
        padding: 40px 24px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .page-404 h1 { font-size: 88px; line-height: 1; color: #147d79; letter-spacing: -.06em; margin: 0 0 24px; }
    .page-404 p { font-size: 18px; color: #657682; margin-bottom: 28px; }
</style>
